/* tslint:disable */
/* eslint-disable */
/**
 * Stadia Maps Geospatial APIs
 * The Stadia Maps Geospatial APIs provide you with the data you need to build awesome applications.
 *
 * The version of the OpenAPI document: 11.1.0
 * Contact: support@stadiamaps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface TzResponse
 */
export interface TzResponse {
  /**
   * The canonical time zone ID.
   *
   * In the event that multiple time zones could be returned,
   * the first one from the Unicode CLDR timezone.xml is returned.
   * @type {string}
   * @memberof TzResponse
   */
  tzId: string;
  /**
   * The base offset, in seconds, from UTC that is normally in effect for this time zone.
   * @type {number}
   * @memberof TzResponse
   */
  baseUtcOffset: number;
  /**
   * The special offset, in seconds, from UTC that is in effect for this time zone as of the queried timestamp (defaults to now).
   *
   * If no additional offsets are in effect, this value is zero.
   * This typically reflects Daylight Saving Time, but may indicate other special offsets.
   * To get the total offset in effect, add `dst_offset` and `utc_offset` together.
   *
   * NOTE: This field can be somewhat confusing.
   * We recommend switching to the v2 endpoint and using the is_dst filed if you need to identify whether DST is being observed.
   * @type {number}
   * @memberof TzResponse
   * @deprecated
   */
  dstOffset: number;
  /**
   * Integer non-leap seconds since January 1, 1970 (UNIX timestamp).
   *
   * If present, offsets will be calculated as of this time.
   * Otherwise, offsets will be effective as of the time of the query.
   * @type {number}
   * @memberof TzResponse
   */
  timestamp: number;
  /**
   * The local time expressed as an RFC 2822 timestamp (e.g. Tue, 1 Jun 2003 10:52:37 -0500).
   *
   * If a timestamp is included in the request, it will be localized here.
   * Otherwise, this will reflect the time of the request.
   *
   * NOTE: RFC 2822 is more restrictive than other formats and cannot represent all dates.
   * @type {string}
   * @memberof TzResponse
   */
  localRfc2822Timestamp?: string | null;
  /**
   * The local time expressed as an RFC 3389 (ISO 8601) timestamp (e.g. 2003-06-01T10:52:37+02:00).
   *
   * If a timestamp is included in the request, it will be localized here.
   * Otherwise, this will reflect the time of the request.
   * @type {string}
   * @memberof TzResponse
   */
  localRfc3389Timestamp: string;
}

/**
 * Check if a given object implements the TzResponse interface.
 */
export function instanceOfTzResponse(value: object): value is TzResponse {
  if (!("tzId" in value) || value["tzId"] === undefined) return false;
  if (!("baseUtcOffset" in value) || value["baseUtcOffset"] === undefined)
    return false;
  if (!("dstOffset" in value) || value["dstOffset"] === undefined) return false;
  if (!("timestamp" in value) || value["timestamp"] === undefined) return false;
  if (
    !("localRfc3389Timestamp" in value) ||
    value["localRfc3389Timestamp"] === undefined
  )
    return false;
  return true;
}

export function TzResponseFromJSON(json: any): TzResponse {
  return TzResponseFromJSONTyped(json, false);
}

export function TzResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): TzResponse {
  if (json == null) {
    return json;
  }
  return {
    tzId: json["tz_id"],
    baseUtcOffset: json["base_utc_offset"],
    dstOffset: json["dst_offset"],
    timestamp: json["timestamp"],
    localRfc2822Timestamp:
      json["local_rfc_2822_timestamp"] == null
        ? undefined
        : json["local_rfc_2822_timestamp"],
    localRfc3389Timestamp: json["local_rfc_3389_timestamp"],
  };
}

export function TzResponseToJSON(json: any): TzResponse {
  return TzResponseToJSONTyped(json, false);
}

export function TzResponseToJSONTyped(
  value?: TzResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    tz_id: value["tzId"],
    base_utc_offset: value["baseUtcOffset"],
    dst_offset: value["dstOffset"],
    timestamp: value["timestamp"],
    local_rfc_2822_timestamp: value["localRfc2822Timestamp"],
    local_rfc_3389_timestamp: value["localRfc3389Timestamp"],
  };
}
